import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Spinner, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getUserProfile } from '../services/userService';
import { useAuth } from '../context/AuthContext';

const ProfilePage = () => {
  const { currentUser } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setLoading(true);
        const response = await getUserProfile();
        
        if (response.success) {
          setProfile(response.user);
        } else {
          setError('Profil bilgileri alınamadı');
        }
      } catch (error) {
        console.error('Profil getirme hatası:', error);
        setError('Profil bilgileri yüklenirken bir hata oluştu');
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  // Cloudinary için resim optimizasyonu
  const getOptimizedProfileImage = (url, size = 200) => {
    if (!url) return '';
    
    if (url.includes('cloudinary.com')) {
      try {
        const parts = url.split('/upload/');
        return `${parts[0]}/upload/w_${size},h_${size},c_fill,g_face/${parts[1]}`;
      } catch (e) {
        return url;
      }
    }
    
    return url;
  };

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Yükleniyor...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-5">
        <Alert variant="danger">
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Row>
        <Col md={4}>
          <Card className="text-center p-4 mb-4">
            <div className="profile-image-container mb-3">
              {profile?.profileImage ? (
                <img 
                  src={getOptimizedProfileImage(profile.profileImage)}
                  alt="Profil Fotoğrafı" 
                  className="rounded-circle img-fluid profile-image"
                  style={{ 
                    width: '200px', 
                    height: '200px', 
                    objectFit: 'cover',
                    border: '1px solid #ddd',
                    margin: '0 auto'
                  }}
                />
              ) : (
                <div 
                  className="default-profile-image rounded-circle d-flex align-items-center justify-content-center"
                  style={{ 
                    width: '200px', 
                    height: '200px',
                    backgroundColor: '#f0f0f0',
                    margin: '0 auto'
                  }}
                >
                  <i className="bi bi-person" style={{ fontSize: '5rem', color: '#ccc' }}></i>
                </div>
              )}
            </div>
            <h3 className="mb-2">{profile?.name || 'İsimsiz Kullanıcı'}</h3>
            {profile?.email && <p className="text-muted mb-2">{profile.email}</p>}
          </Card>
        </Col>
        
        <Col md={8}>
          <Card className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2>Profil Bilgileri</h2>
              <Link to="/profile/edit">
                <Button variant="primary">
                  <i className="bi bi-pencil me-2"></i>
                  Profili Düzenle
                </Button>
              </Link>
            </div>
            
            <Row className="mb-3">
              <Col sm={4} className="fw-bold">Ad Soyad:</Col>
              <Col sm={8}>{profile?.name || 'Belirtilmemiş'}</Col>
            </Row>
            
            <Row className="mb-3">
              <Col sm={4} className="fw-bold">E-posta:</Col>
              <Col sm={8}>{profile?.email || 'Belirtilmemiş'}</Col>
            </Row>
            
            <Row className="mb-3">
              <Col sm={4} className="fw-bold">Telefon:</Col>
              <Col sm={8}>{profile?.phone || 'Belirtilmemiş'}</Col>
            </Row>
            
            <Row className="mb-3">
              <Col sm={4} className="fw-bold">Adres:</Col>
              <Col sm={8}>{profile?.address || 'Belirtilmemiş'}</Col>
            </Row>
            
            <Row className="mb-3">
              <Col sm={4} className="fw-bold">Kayıt Tarihi:</Col>
              <Col sm={8}>
                {profile?.createdAt 
                  ? new Date(profile.createdAt).toLocaleDateString('tr-TR') 
                  : 'Belirtilmemiş'
                }
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ProfilePage;